import React from 'react';
import { Cancel, FiberManualRecord } from '@material-ui/icons';

export const StatusDisplay = ({ status }) => {
    const statuses = {
        pending: {
            color: 'gray',
            label: 'Pending',
        },
        payable: {
            color: 'red',
            label: 'Awaiting Payment',
        },
        complete: { color: 'green', label: 'Complete' },
        routedComplete: { color: 'green', label: 'Routed Complete' },
        on_hold: { color: 'yellow', label: 'On Hold' },
        claimed: { color: 'blue', label: 'Claimed' },
        inProgress: { color: 'blue', label: 'In Progress' },
        routedOpen: { color: '#dece28', label: 'Open' },
        routedInProgress: { color: 'blue', label: 'In Progress' },
        routedActive: { color: 'blue', label: 'Claimed' },
        open: { color: '#dece28', label: 'Open' },
        cancelled: {
            color: 'red',
            label: 'Cancelled',
        },
        routed: { color: 'gray', label: 'Pending' },
        unableToDeliver: { color: 'red', label: 'Unable to Deliver' },
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {status === 'cancelled' ? (
                <Cancel
                    style={{
                        color: 'red',
                        fontSize: 13,
                        marginBottom: '1px',
                        marginRight: '2px',
                    }}
                />
            ) : (
                <FiberManualRecord
                    style={{
                        color: statuses[status] && statuses[status].color ? statuses[status].color : 'white',
                        fontSize: 13,
                        marginBottom: '1px',
                        marginRight: '2px',
                    }}
                />
            )}
            {statuses[status] ? <div>{statuses[status].label}</div> : status}
            {/* {statuses[status].label || status} */}
        </div>
    );
};

export default [
    {
        label: 'Order',
        value: (order) => order.order_number,
    },
    {
        label: 'Shipper',
        value: (order) => order.business_name,
    },
    {
        label: 'Origin',
        value: (order) => order.pickup_city,
    },
    {
        label: 'Destination',
        value: (order) => order.dropoff_city,
    },
    {
        label: 'Delivery Type',
        value: (order) => {
            if (order.dropoff_location === 'Residence') {
                return order.dropoff_location_type;
            } else if (order.dropoff_location === 'Business') {
                return order.dropoff_location_info;
            }
        },
    },
    {
        label: 'Cubic Feet',
        value: (order) => {
            if (order.order_type === 'return' && order.returns_total_cubes) {
                return parseFloat(order.returns_total_cubes).toFixed(2);
            }

            return order.items_total_cubes ? parseFloat(order.items_total_cubes).toFixed(2) : '--';
        },
    },
    {
        label: 'First Available',
        value: (order) => (order.first_available_date ? order.first_available_date : 'TBD'),
    },
    {
        label: 'Status',
        value: (order) => <StatusDisplay status={order.order_status} />,
    },
];
